import { forwardRef } from 'react';
import { Camp } from '../../utils/types';
import CampContent from './CampContent';
import './CampDetails.css';

interface CampDetailsProps {
  camp: Camp;
  isOpen: boolean;
  onClose: () => void;
  selectedDate?: string;
  onDateChange?: (campId: string, dateId: string) => void;
  favoriteId?: string;
  scheduledDateIds?: string[];
  newsletterSignupEnabled?: boolean;
  onSimilarCampClick?: (camp: Camp) => void;
}

const CampDetails = forwardRef<HTMLDivElement, CampDetailsProps>(({
  camp,
  isOpen,
  onClose,
  scheduledDateIds,
  newsletterSignupEnabled = false,
  onSimilarCampClick
}, ref) => {
  if (!isOpen) return null;

  return (
    <div className="camp-details-overlay" onClick={onClose}>
      <div className="camp-details-modal" ref={ref} onClick={(e) => e.stopPropagation()}>
        <button className="camp-details-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <CampContent
          camp={camp}
          variant="modal"
          scheduledDateIds={scheduledDateIds}
          onSimilarCampClick={onSimilarCampClick}
          newsletterSignupEnabled={newsletterSignupEnabled}
          analyticsPrefix="camp_details"
        />
      </div>
    </div>
  );
});

export default CampDetails;
